import { useMaxTierEnabled } from '#pplx/frontend/apps/ask/providers/hooks/useMaxTierEnabled.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useMemo } from 'react';
export function useMaxUpsell() {
    const { isMax, isPro } = useIsSubscribed();
    const { isMaxUpsellEnabled } = useMaxTierEnabled();
    const { gpt4Limit, pplxAlphaLimit } = useThreadConfig();
    const shouldRenderMaxUpsell = useMemo(() => {
        return (searchMode) => {
            const hasRunOutOfQueries = !gpt4Limit.available || !pplxAlphaLimit.available;
            return (isMaxUpsellEnabled &&
                !isMax &&
                isPro &&
                hasRunOutOfQueries &&
                (searchMode === SearchMode.RESEARCH || searchMode === SearchMode.AGENTIC_RESEARCH));
        };
    }, [isMaxUpsellEnabled, isMax, isPro, gpt4Limit, pplxAlphaLimit]);
    return shouldRenderMaxUpsell;
}
//# sourceMappingURL=useMaxUpsell.js.map